module.exports = __webpack_public_path__ + "static/media/dorood_bar_shomaa.472aa4aa.png";